import request from './index'

export const GetTalentRecruitment = params => {
  return request({
    method: 'GET',
    url: '/api/dynamic/shangshidongtand34b9aa9d4c0bbf0217b4',
    params
  })
}

// 获取科室信息
export const GetDepart = params => {
  return request({
    method: 'GET',
    url: '/api/dynamic/shangshidongtan974065a8514e9dc99bf40',
    params
  })
}

// 获取科室信息详情
// export const GetDepartDetail = params => {
//   return request({
//     method: 'GET',
//     url: '/api/dynamic/shangshidongtan974065a8514e9dc99bf40',
//     params
//   })
// }

// 获取科室下面的医生
export const GetDoctor = params => {
  return request({
    method: 'GET',
    url: '/api/dynamic/shangshidongtana84cf98930d12cb0b1fe3',
    params
  })
}

// 获取科室下面的医生
export const GetDoctorDetail = params => {
  return request({
    method: 'GET',
    url: '/api/dynamic/shangshidongtan1c4ce292f5c779fd2ee1c',
    params
  })
}


// 轮播图
export const GetImg = params => {
  return request({
    method: 'GET',
    url: '/api/dynamic/shangshidongtanc44a16b36869d3aa05773',
    params
  })
}

// 获取字典
export const getDictionary = params => {
  return request({
    method: 'GET',
    url: '/api/dynamic/shangshidongtan144985b73010f4b74bef5',
    params
  })
}

